/** @enum {number} */
const PanelType = Object.freeze({
    LOAD: 0,
    DOWNLOAD: 1,
    FILTER: 2,
    EDIT: 3,
    UPSCALE: 4,
    RESIZE: 5,
    CROP: 6
})

export default PanelType;